import { Form } from "@circle-react-uikit/Form";

export const HiddenSignUpFields = () => (
  <div className="hidden">
    <Form.Item
      hiddenField
      name="user[affiliate_code]"
      hideDescription
      hideBorder
      hideLabel
    >
      <Form.Input type="hidden" />
    </Form.Item>

    <Form.Item
      hiddenField
      name="user[invitation_token]"
      hideDescription
      hideBorder
      hideLabel
    >
      <Form.Input type="hidden" />
    </Form.Item>

    <Form.Item
      hiddenField
      name="user[community_id]"
      hideDescription
      hideBorder
      hideLabel
    >
      <Form.Input type="hidden" />
    </Form.Item>

    <Form.Item
      name="user[affiliate_ref]"
      hiddenField
      hideDescription
      hideBorder
      hideLabel
    >
      <Form.Input type="hidden" />
    </Form.Item>
  </div>
);
